import { TaskStatus } from '../../types/TaskStatus';
import colorTokens from './colors';

export enum StatusColor {
  grey = 'grey',
  blue = 'blue',
  yellow = 'yellow',
  orange = 'orange',
  red = 'red',
  purple = 'purple',
  green = 'green',
}

export const statusTextColorMap: { [key in TaskStatus['color']]: string } = {
  grey: colorTokens.neutral[800],
  blue: colorTokens.blue[600],
  yellow: colorTokens.yellow[600],
  orange: colorTokens.orange[600],
  red: colorTokens.red[600],
  purple: colorTokens.purple[600],
  green: colorTokens.green[600],
};

export const statusColorMap: { [key in TaskStatus['color']]: string } = {
  grey: colorTokens.neutral[200],
  blue: colorTokens.blue[100],
  yellow: colorTokens.yellow[100],
  orange: colorTokens.orange[100],
  red: colorTokens.red[100],
  purple: colorTokens.purple[100],
  green: colorTokens.green[100],
};

export const statusDarkerColorMap: { [key in TaskStatus['color']]: string } = {
  grey: colorTokens.neutral[300],
  blue: colorTokens.blue[200],
  yellow: colorTokens.yellow[200],
  orange: colorTokens.orange[200],
  red: colorTokens.red[200],
  purple: colorTokens.purple[200],
  green: colorTokens.green[200],
};
